import { render, staticRenderFns } from "./simpleDialog.vue?vue&type=template&id=0561bd6c&"
import script from "./simpleDialog.vue?vue&type=script&lang=js&"
export * from "./simpleDialog.vue?vue&type=script&lang=js&"
import style0 from "./simpleDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
